import { UseFormGetFieldState, UseFormRegister } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext';
import { getTextFieldState, PosTextField } from 'src/core/POS/PosTextField';
import { Stack } from 'src/core/ui/Stack';
import { ContentId } from 'src/utils/constants/contentId';

import { SaleInvoiceFormData } from './SaleInvoiceOptionsPopover';
import * as styles from './SaleInvoiceOptionsPopover.css';
export const SaleInvoiceAddressInput = ({
  type,
  register,
  getFieldState,
}: {
  type: 'shipping' | 'billing';
  register: UseFormRegister<SaleInvoiceFormData>;
  getFieldState: UseFormGetFieldState<SaleInvoiceFormData>;
}) => {
  return (
    <Stack direction="column" gap="s">
      <PosTextField
        rootProps={{
          state: getTextFieldState(getFieldState(`${type}.name`)?.error),
        }}
        prefixDisplay={
          <div className={styles.inputPrefix}>
            <Content id={ContentId.Name} />
          </div>
        }
        {...register(`${type}.name`)}
      />
      <PosTextField
        rootProps={{
          state: getTextFieldState(getFieldState(`${type}.address`)?.error),
        }}
        prefixDisplay={
          <div className={styles.inputPrefix}>
            <Content id={ContentId.Address} />
          </div>
        }
        {...register(`${type}.address`)}
      />
      <Stack direction="row" gap="m">
        <PosTextField
          rootProps={{
            state: getTextFieldState(getFieldState(`${type}.city`)?.error),
          }}
          prefixDisplay={
            <div className={styles.inputPrefix}>
              <Content id={ContentId.City} />
            </div>
          }
          {...register(`${type}.city`)}
        />

        <PosTextField
          rootProps={{
            state: getTextFieldState(getFieldState(`${type}.state`)?.error),
          }}
          prefixDisplay={
            <div className={styles.inputPrefix}>
              <Content id={ContentId.State} />
            </div>
          }
          {...register(`${type}.state`)}
        />
      </Stack>

      <Stack direction="row" gap="m">
        <PosTextField
          rootProps={{
            state: getTextFieldState(getFieldState(`${type}.zip`)?.error),
          }}
          prefixDisplay={
            <div className={styles.inputPrefix}>
              <Content id={ContentId.ZipCode} />
            </div>
          }
          {...register(`${type}.zip`)}
        />

        <PosTextField
          rootProps={{
            state: getTextFieldState(getFieldState(`${type}.country`)?.error),
          }}
          prefixDisplay={
            <div className={styles.inputPrefix}>
              <Content id={ContentId.Country} />
            </div>
          }
          {...register(`${type}.country`)}
        />
      </Stack>

      <PosTextField
        rootProps={{
          state: getTextFieldState(getFieldState(`${type}.phoneNumber`)?.error),
        }}
        prefixDisplay={
          <div className={styles.inputPrefix}>
            <Content id={ContentId.Phone} />
          </div>
        }
        {...register(`${type}.phoneNumber`)}
      />
    </Stack>
  );
};
